import { jsx as _jsx } from "react/jsx-runtime";
import { CheckCircleFilled, ExclamationCircleOutlined } from "@ant-design/icons";
import { DEFAULT_LANGUAGE } from "@devowl-wp/api-real-cookie-banner";
import { getTranslationStateColor, getTranslationStateTooltip } from "./translation-status.js";
import { useTranslation } from "../../../../../../../others/i18n.js";
import { getFieldNameTranslated } from "../../../../../../../util/template/translation.js";
import { ColumnToolTipHeader } from "../../../../../../table/column-tooltip-header.js";
/**
 * Creates the translation status columns for the table.
 * @param language The language to create the columns for.
 * @returns The translation status columns for the table.
 */ function useTranslationStatusColumns(language) {
    const { t } = useTranslation();
    const columns = [
        {
            title: t("Field name"),
            dataIndex: "name",
            render: (name)=>{
                return getFieldNameTranslated(name, t);
            }
        },
        {
            title: t("Source string"),
            dataIndex: "baseTranslationState",
            render: (baseTranslationState, record)=>{
                return renderTranslatedState(baseTranslationState, record, t);
            },
            align: "center"
        },
        {
            title: /*#__PURE__*/ _jsx(ColumnToolTipHeader, {
                columnName: t("Optional"),
                tooltipTitle: t("Indicates whether the translation is optional")
            }),
            dataIndex: "isOptional",
            render: (isOptional, record)=>{
                if (isOptional === true) {
                    return /*#__PURE__*/ _jsx(CheckCircleFilled, {
                        style: {
                            color: "lightgreen"
                        }
                    }, `${record.name}-isOptional`);
                } else {
                    return "-";
                }
            },
            align: "center"
        }
    ];
    // When the given language is the default language hide this column
    if (language !== DEFAULT_LANGUAGE) {
        columns.push({
            title: t("Translation status"),
            dataIndex: "translationState",
            render: (translationState, record)=>{
                return renderTranslatedState(translationState, record, t);
            },
            align: "center"
        });
    }
    return columns;
}
/**
 * Renders the translation state of a field.
 * @param state The translation state of the field.
 * @param record The record of the field.
 * @param t The translation function.
 * @returns
 */ function renderTranslatedState(state, record, t) {
    const key = `${record.name}-translation-state`;
    if (state !== "Missing") {
        return /*#__PURE__*/ _jsx(CheckCircleFilled, {
            style: {
                color: getTranslationStateColor(state)
            },
            title: getTranslationStateTooltip(state, record.isOptional, t)
        }, key);
    } else if (state === "Missing" && record.baseTranslationState !== "Missing" && !record.isOptional) {
        return /*#__PURE__*/ _jsx(ExclamationCircleOutlined, {
            style: {
                color: "red"
            },
            title: getTranslationStateTooltip(state, record.isOptional, t)
        }, key);
    } else {
        return "-";
    }
}
export { useTranslationStatusColumns };
